/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetAudienceSeenPathParams = NonNullable<operations['getAudienceSeen']['parameters']['path']>;

export type GetAudienceSeenQueryParams = NonNullable<operations['getAudienceSeen']['parameters']['query']>;

export interface Input extends GetAudienceSeenPathParams {
  apiVersion?: string;
  query: GetAudienceSeenQueryParams;
}

export async function getAudienceSeen(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projectKey}/flags/{flagKey}/environments/{environmentKey}/audience', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
